import { render, staticRenderFns } from "./BusinessCentralLoader.vue?vue&type=template&id=25c1ec11&"
import script from "./BusinessCentralLoader.vue?vue&type=script&lang=ts&"
export * from "./BusinessCentralLoader.vue?vue&type=script&lang=ts&"
import style0 from "./BusinessCentralLoader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports